import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Atmospheric%20concert%20stage%20with%20warm%20red%20and%20amber%20stage%20lighting%2C%20silhouette%20of%20audience%20with%20raised%20hands%2C%20dramatic%20smoke%20effects%2C%20powerful%20live%20music%20atmosphere%2C%20emotional%20and%20energetic%20crowd%2C%20high%20contrast%20photography%2C%20epic%20concert%20moment%2C%20no%20visible%20faces%20or%20text%2C%20abstract%20celebration%20of%20music&width=1920&height=900&seq=soniem-cta-bg-01&orientation=landscape"
          alt="Concierto en vivo - Únete a SONIEM"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/85 to-foreground-950/70" />
        <div className="absolute inset-0 bg-primary-900/15 mix-blend-multiply" />
      </div>

      {/* Content */}
      <div className="relative z-10 px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-400 mb-4">
            ¿Eres artista musical?
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Protege tu música,{' '}
            <span className="text-primary-400">recibe tus regalías</span>
          </h2>
          <p className="text-white/60 text-base md:text-lg max-w-xl mx-auto mb-10 leading-relaxed">
            Afíliate a SONIEM y empieza a recibir lo que te corresponde por la 
            reproducción de tu música en radio, televisión, plataformas digitales 
            y locales comerciales.
          </p>

          {/* CTA Button */}
          <Link
            to="/contacto"
            className="group inline-flex items-center gap-3 px-10 py-5 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            <span>Quiero Afiliarme</span>
            <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center group-hover:translate-x-1 transition-transform">
              <i className="ri-arrow-right-up-line text-white text-sm" />
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}